import { createContext, FC, PropsWithChildren, useContext } from "react";
import { useJuicySessionId } from "@/helpers/useJuicySessionId";
import { useAppSelector } from "@/store/store";
import {
  selectContactId,
  selectIsAuth,
  selectNullableApplicationId,
} from "@/store/selectors";
import { JuicyScoreApi } from "@/server/agent";
import { useEffectAsync } from "@/helpers/useEffectAsync";

const JuicySessionContext = createContext<{ sessionId: null | string }>({
  sessionId: null,
});

export const JuicySession: FC<PropsWithChildren> = ({ children }) => {
  const isAuth = useAppSelector(selectIsAuth);
  const applicationId = useAppSelector(selectNullableApplicationId);
  const contactId = useAppSelector(selectContactId);
  const sessionId = useJuicySessionId(!isAuth);

  useEffectAsync(
    async (signal) => {
      if ((sessionId || sessionId === "") && applicationId && contactId) {
        JuicyScoreApi.saveSession(
          {
            sessionId,
            applicationId,
            contactId,
          },
          signal
        );
      }
    },
    [sessionId, applicationId, contactId]
  );

  return (
    <JuicySessionContext.Provider value={{ sessionId }}>
      {children}
    </JuicySessionContext.Provider>
  );
};

export const useGetJuicySessionId = () =>
  useContext(JuicySessionContext).sessionId;
